import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app";
import logging from "./util/logging";
import "./styles.scss";

function noop() {
  // no operation
}

if (!import.meta.env.DEV) {
  console.log = noop;
  console.info = noop;
  console.warn = noop;
  console.error = noop;
}

const log = logging("index");

window.onerror = (
  msg: Event | string,
  _url?: string,
  _line?: number,
  _col?: number,
  error?: Error,
) => {
  log.error(msg as string, error);
};

log.info("Starting up the application...");

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
